import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Header } from './components/Header';
import { HomePage } from './pages/HomePage';
import { SearchResultsPage } from './pages/SearchResultsPage';
import { RestaurantDetailPage } from './pages/RestaurantDetailPage';
import { ViewState } from './types';
import { mockRestaurants } from './utils/mockData';
export function App() {
  const [currentView, setCurrentView] = useState<ViewState>('home');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRestaurantId, setSelectedRestaurantId] = useState<string | null>(null);
  // Scroll to top on view change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentView, selectedRestaurantId]);
  const handleSearch = (query: string) => {
    setSearchQuery(query);
    setCurrentView('search');
  };
  const handleSelectRestaurant = (id: string) => {
    setSelectedRestaurantId(id);
    setCurrentView('detail');
  };
  const handleNavigateHome = () => {
    setCurrentView('home');
    setSearchQuery('');
    setSelectedRestaurantId(null);
  };
  const handleBackFromDetail = () => {
    if (searchQuery) {
      setCurrentView('search');
    } else {
      setCurrentView('home');
    }
    setSelectedRestaurantId(null);
  };
  const selectedRestaurant = selectedRestaurantId ? mockRestaurants.find(r => r.id === selectedRestaurantId) : null;
  return <div className="h-screen flex flex-col bg-slate-50 font-sans text-slate-900 selection:bg-teal-200 selection:text-teal-900 overflow-hidden" data-id="element-0">
      <Header onNavigateHome={handleNavigateHome} data-id="element-1" />

      <main className="flex-1 relative w-full overflow-hidden flex flex-col" data-id="element-2">
        <AnimatePresence mode="wait" data-id="element-3">
          {currentView === 'home' && <HomePage key="home" onSearch={handleSearch} onSelectRestaurant={handleSelectRestaurant} data-id="element-4" />}

          {currentView === 'search' && <SearchResultsPage key="search" query={searchQuery} onSearch={handleSearch} onSelectRestaurant={handleSelectRestaurant} data-id="element-5" />}

          {currentView === 'detail' && selectedRestaurant && <div className="absolute inset-0 z-50 bg-slate-50 overflow-y-auto" data-id="element-6">
              <RestaurantDetailPage key="detail" restaurant={selectedRestaurant} onBack={handleBackFromDetail} data-id="element-7" />
            </div>}
        </AnimatePresence>
      </main>
    </div>;
}